import React from "react";
import { motion } from "framer-motion"; // For animations
import "./Home.css";
import QuoteGenerator from "../QuoteGenerator/QuoteGenerator";
import Avatar from "../Avatar/Avatar";
import Testimonials from "../Testimonials/Testimonials";

const Home = () => {
  return (
    <section className="section flex flex-col items-center text-center relative overflow-hidden">
            {/* <div className="animated-background absolute inset-0 -z-10"
            ></div> */}
      {/* Animated Avatar */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        className="avatar-container mb-6"
      >
        <Avatar />
      </motion.div>
      {/* <div className="max-w-7xl mx-auto px-6"> */}
      {/* Welcome Text */}
      <motion.h1
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        className="heading-main mb-4"
      >
        Welcome to My Portfolio!
      </motion.h1>

      {/* Quote Generator with Animation */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <QuoteGenerator />
      </motion.div>

      {/* About Me */}
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.8 }}
        className="paragraph max-w-2xl mx-auto mb-6 text-lg text-gray-600"
      >
        I'm a passionate software engineer with experience in <b>C#, .NET, Angular, React, and SharePoint</b>. 
        Check out my <b>latest projects</b> and see what I've been working on!
      </motion.p>

      {/* Testimonials Section */}
      <Testimonials />

      {/* Projects Section */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.6, duration: 0.8 }}
        className="mt-8"
      >
        <h2 className="heading-sub mb-3">Recent Projects</h2>
        <p className="paragraph text-lg">
          Check out my work in the{" "}
          <a href="/projects" className="text-gray-500 hover:text-gray-700">
            Projects
          </a>{" "}
          section.
        </p>
      </motion.div>

      {/* Background Animation (Optional) */}
      <div className="absolute inset-0 -z-10">
        <div className="gradient-overlay"></div>
      </div>
      {/* </div> */}
    </section>
  );
};

export default Home;
